import { Popup, Toast } from 'antd-mobile';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import fabric from '@/pages/customize/utils/newFabric';
import * as PIXI from 'pixi.js';
import { OutlineFilter } from '@pixi/filter-outline';
import './index.scss';
import DrawUtilFunc from './DrawUtilFunc';
import util from './util';

let app = null;
const defaultSize = 5000; // 判断字节书是否小4.8KB, 如果小于,则canvas 可能没绘画完成
let minPoint = { x: 9999, y: 9999 }; // 给最高点一个默认初始值, 用户获取图片位置的顶点作坐标
let canvasIns; // 主canvas 对象
let canvasConfig = {
  top: 35, // 避免图片时最顶上的,添加20的阀值, 避免空洞打不上去
  kong: 20, // 孔距离顶部的巨鹿
  offset: 10, // 画最终的宽度,需要比图片高一点
  pointLeft: 4, // 顶点偏移, 防止获取到空洞的坐标,
  pointTop: 40, // 空洞向下的距离
  maxCanvasHeight: 80, // 画布需要增加的高度 边框 + 空洞
  pixiHeight: 90
};
let retry = 0; // 绘画导出重试次数, 避免死循环了, 到目前没有发生过
const Preview = forwardRef((props: any, ref: any) => {
  const { previewVisible, setPreviewVisible, canvasData, onOk } = props;
  const [cover, setCover] = useState<string>('');
  // url: 链接, thickness描边   container 容器, color 边框颜色
  const addImage = (url, thickness, container, color) => {
    const texture = PIXI.Texture.from(url);
    const bunny: any = new PIXI.Sprite(texture);
    bunny.anchor.set(0.5);
    bunny.scale.x = 0.9;
    bunny.scale.y = 0.9;
    bunny.x = window.innerWidth / 2;
    bunny.y = (canvasData.height + canvasConfig.maxCanvasHeight) / 2;
    // bunny.filters = [new OutlineFilter(thickness, color, 1)];
    container.stage.addChild(bunny);
    app.render();
  };

  const addCir = async () => {
    return new Promise(resolve => {
      fabric.loadSVGFromURL('https://static.hhocool.com/files/b5a21022-a15f-47fa-83fd-e166709cd51b_Subtract.svg', function (objects, options) {
        const visiableArea = fabric.util.groupSVGElements(objects, options);
        visiableArea.selectable = false
        visiableArea.absolutePositioned = true
        visiableArea.crossOrigin = 'anonymous'
        visiableArea.excludeFromExport = true
        visiableArea.id = 'pathRect'
        visiableArea.left = minPoint.x - canvasConfig.pointLeft
        visiableArea.top = minPoint.y + canvasConfig.pointTop
        visiableArea.scaleToWidth(30)

        canvasIns.add(visiableArea);
        resolve(null)
      });
    })
  };


  const imageLoad = () => {
    app.render();
    app.renderer.extract.canvas().toBlob((blob: any) => {
      if (blob.size < defaultSize && retry < 3) {
        requestAnimationFrame(imageLoad);
        retry += 1;
        return;
      }
      const url = URL.createObjectURL(blob);
      setCover(url);
      setPreviewVisible(true);
      Toast.clear();
      retry = 0;
    }, 'image/png');
  };

  // 创建一个canvas
  const createCanvas = (id) => {
    let canvasEl = document.createElement('canvas');
    canvasEl.id = id;
    canvasIns = new fabric.Canvas(canvasEl, {
      controlsAboveOverlay: true,
      enableRetinaScaling: true,
      selection: false
    });
    canvasIns.setWidth(window.innerWidth);
    canvasIns.setHeight(canvasData.height + canvasConfig.maxCanvasHeight);
  };

  useImperativeHandle(ref, () => ({
    toPreview(previewUrl) {
      (async () => {
        // 曲线顶点坐标数组，points[i] 是第 i 个点的 x 坐标，points[i+1] 是第 i 个点的 y 坐标
        let points = [];
        // 创建canvas
        createCanvas('preview_canvas_one');
        let arr = await util.getImage(previewUrl);
        minPoint = util.getTopPoint(arr);
        fabric.Image.fromURL(previewUrl, async (oImg) => {
          oImg.set({
            top: canvasConfig.top + canvasConfig.top,
            left: canvasConfig.offset
          });
          canvasIns.add(oImg); // 添加图片
          await addCir(); // 添加孔洞
          const newUrl = canvasIns.toDataURL({
            format: 'png',
            quality: 1,
            multiplier: 1
          });
          arr = await util.getImage(newUrl);
          if (arr < 20) {
            points = arr;
          } else {
            points = util.getLinePoint(arr);
          }
          // newUrl 图片url
          // points 点位
          // 0.5 顺滑程度
          // false 是否在图片上层
          let drawUtil = new DrawUtilFunc(canvasIns);
          drawUtil.drawSmoothCurve(newUrl, points, 0.5, false, 10, minPoint.x - canvasConfig.pointLeft, minPoint.y + canvasConfig.pointTop, () => {
            const dataUrl = canvasIns.toDataURL({
              format: 'png',
              quality: 1,
              multiplier: 1
            });

            app = new PIXI.Application({
              width: window.innerWidth,
              height: canvasData.height + canvasConfig.pixiHeight,
              antialias: true, //  使得字体的边界和几何图形更加圆滑（WebGL的anti-aliasing不是在所有平台都可用，所以你需要在你的游戏的目标平台上测试他们）
              transparent: true,
              resolution: 1,
              forceCanvas: false // 强制使用canvas 引擎
            });
            let container = document.createElement('div'); // document.createElement('div');
            container.appendChild(app.view);
            addImage(dataUrl, 2, app, '0x000000');
            requestAnimationFrame(imageLoad);
          });
        });
      })();
    },
    toImgPreview(url) {
      setCover(url);
      setPreviewVisible(true);
    }
  }));
  return (
    <Popup
      visible={previewVisible}
      mask={true}
      onMaskClick={() => {
        setPreviewVisible(false);
      }}
      onClose={() => {
        setPreviewVisible(false);
      }}
      bodyStyle={{ borderRadius: '16px 16px 0 0' }}
      showCloseButton
      style={{
        '--z-index': '1004'
      }}
    >
      <div className='preview-con'>
        <div style={{ fontSize: 16, padding: '19px 0', textAlign: 'center' }}>Preview</div>
        <div className='preview-box' style={{ backgroundImage: 'radial-gradient(#e8e8e8, #b4bac6)' }}>
          {cover ? <img className='preview-cover' src={cover} alt='' /> : null}
        </div>
        <div style={{ width: '93.6%', height: 40, borderRadius: 20, color: 'white', fontSize: 14, backgroundColor: 'rgb(238,126,49)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14, marginTop: 14 }}
          onClick={()=>onOk(cover)}
        >Confirm</div>
      </div>
    </Popup>
  );
});

export default Preview;
